// English-only for now; move into src/locales if the phone UX graduates.
const strings = {
  back: 'Back to songs',
  myPart: 'MY PART',
  everyone: 'EVERYONE',
  others: 'OTHERS',
  blendLabel: 'Balance between my part and the other parts',
  pickMyPart: 'Pick my part',
  show: 'Show',
  showMine: 'My part',
  showAll: 'All parts',
  showCustom: 'Custom',
  zoomOut: 'Smaller notation',
  zoomIn: 'Larger notation',
  play: 'Play',
  pause: 'Pause',
  stop: 'Stop',
  slower: 'Slower',
  faster: 'Faster',
  bpm: 'Tempo in beats per minute',
  metronome: 'Metronome',
  moreControls: 'Show more controls',
  hideControls: 'Hide controls',
  more: 'More',
  close: 'Close',
  groupSection: 'Playback',
  groupSound: 'Sound',
  groupRhythm: 'Rhythm',
  swingUnavailable: 'Swing is available for scores in 2/4, 4/4 or 2/2 time.',
  groupParts: 'Parts',
  groupDisplay: 'Display',
  groupPresets: 'Presets',
  groupSong: 'Song',
  loop: 'Loop',
  clearSelection: 'Clear',
  sectionHint: 'Tap a measure on the score to start a section, then tap another to end it.',
  respectRepeats: 'Respect repeats',
  swing: 'Swing',
  transpose: 'Transpose',
  tutorial: 'Tutorial',
  pdf: 'PDF as shown',
  pdfOfficial: 'Official PDF',
  mp3: 'MP3',
  resetSettings: 'Reset settings',
  bpmUnit: 'bpm',
  tempoLabel: 'Tempo',
  zoomLabel: 'Size',
  collapseControls: 'Collapse controls',
  chooseSong: 'Choose a song',
  changeSong: 'Tap to change song',
  searchSongs: 'Search songs',
  loadingSongs: 'Loading songs…',
  songsFailed: 'Could not load the song list.',
  noSongs: 'No songs yet.',
  noMatches: 'No songs match.',
  recent: 'Recently practiced',
  loadFromDevice: 'Open a file from this device',
  downloadFailed: 'Could not download that song. Please try again.',
  sectionBars: 'Bars',
  sectionBar: 'Bar',
  sectionLooping: 'looping',
  sectionOnce: 'plays once (grading)',
  sectionFromTap: 'tap another bar to end the section',
  stopToChange: 'Stop playback to change this.',
  stopToChangeSong: 'Stop playback to choose another song.',
  hoverPlay: 'Hover to hear',
  hoverPlayHint: 'Point at a note to hear it. Play and bar selection are off while this is on.',
  hoverPlayOn: 'On: point at a note to hear it. Esc turns it off.',
  hoverPlayBanner: 'Hover to hear is on',
  hoverPlayExit: 'Exit (Esc)',
  wholeChord: 'Whole chord',
  wholeChordHint: 'Also play everything else sounding at that moment.',
  stepHints: 'Step hints',
  stepHintsHint: '\u00BD or 1 between the notes of my part where it moves by a second',
  stepHintsNeedMe: 'Pick my part to show half- and whole-step hints.',
  lyrics: 'Lyrics',
  lyricsHint: 'the word being sung, large over the score while playing',
  lyricsNone: 'This song has no lyrics.',
  lyricsWordsOf: 'Words of',
  lyricsMineHasNone: 'my part has none',
  lyricsMode: 'Show',
  lyricsModeTip: 'Word: the word being sung, as large as it fits. Phrase: the whole phrase a little smaller, shown a moment early so you can read ahead. Magnify (experimental): my part drawn large across the bottom, gliding as it plays, with the phrase underneath.',
  lyricsWord: 'Word',
  lyricsPhrase: 'Phrase',
  lyricsMagnify: 'Magnify',
  magnify: 'Magnify my part, with the words',
  lyricsVerse: 'Verse',
  lyricsVerseAuto: 'Follow repeats',
  grade: 'Grade my pitch',
  gradeHint: 'Sing along with your headset on; each note of my part is marked on the score.',
  gradeNeedMe: 'Pick my part to grade it.',
  gradeOn: 'Play counts in one bar and every note of my part is graded. A highlighted section plays once, so just those bars are graded.',
  gradeReady: 'press Play, one bar is counted in',
  gradeListening: 'Listening',
  gradeTuning: 'Tuning',
  gradeEqual: 'Equal',
  gradeJust: 'Just',
  gradeEqualHint: 'equal temperament, as the piano plays',
  gradeJustHint: 'each note tuned to the chord in the other parts: thirds about 14¢ low, fifths 2¢ high',
  gradeHide: 'Hide',
  gradeShow: 'Show',
  gradeClear: 'Clear',
  gradePlay: 'Play take',
  gradePlaySection: 'Play section',
  gradePlayStop: 'Stop',
  gradePlayTitle: 'Play the graded take back',
  gradePlaySectionTitle: 'Play my singing of the highlighted section',
  gradeDownload: 'Save graded take',
  gradeDownloadTitle: 'Save the graded take as a WAV file, with its grading analysis inside (for troubleshooting)',
  recorder: 'Scratch recorder',
  recorderTip: 'Record yourself, then play the take back or download it. Hold to record plays it back as soon as you let go. Record with playback starts the song with a one-bar count-in and stops recording when the song stops. With a section highlighted, Play plays just your singing of it. Use headphones so the mic does not pick up the accompaniment.',
  deviceInput: 'Microphone',
  deviceInputTip: 'The mic used for graded takes, the scratch recorder and the pitch monitor. Remembered on this computer.',
  deviceInputWindows: "turn off this mic's Audio enhancements in Windows",
  deviceInputWindowsTip: "Windows' Audio enhancements on a mic can duck the sound and chop held notes, out of the browser's sight. Turn them off in Settings → System → Sound → (your mic) → Audio enhancements: Off, and in the laptop's own audio app if it has one. They are set per mic, and updates can switch them back on.",
  deviceOutput: 'Output',
  deviceOutputTip: 'Where the song, the metronome and your takes play. Remembered on this computer.',
  deviceDefault: 'System default',
  devicesUnnamed: 'names appear once the mic has been allowed',
  monitor: 'Pitch monitor',
  monitorOpen: 'Open',
  monitorHint: 'sing or hum and see live what the grader hears',
  gradeLive: 'Grade while singing',
  gradeLiveOn: 'grades appear as you sing; this can nudge playback timing',
  gradeLiveOff: 'grades appear when you stop or the song ends (smoothest playback)',
  highlightSync: 'Highlight sync',
  highlightSyncHint: 'ms; raise it if the highlight runs ahead of the sound',
  partsOverride: 'Override',
  partsOverrideOn: 'Parts override is on: the individual part controls drive the mix.',
  partsOverrideOff: 'Turn on Override to hear or show individual parts. Otherwise the blend slider and Show toggle drive the mix.'
};

export default strings;
